
import React from "react";
import { useUserReports } from "@/hooks/useUserReports";
import { useAuth } from "@/context/auth/AuthContext";
import { Card, CardContent } from "@/components/ui/card";
import { ReportsList } from "@/components/reports/ReportsList";
import { ReportLoading } from "@/components/reports/ReportLoading";
import { NoReportsFound } from "@/components/reports/NoReportsFound";
import { ReportsHeader } from "@/components/reports/ReportsHeader";
import { ReportsPagination } from "@/components/reports/ReportsPagination";

const TeacherReportsPage: React.FC = () => {
  const { user } = useAuth();
  const { 
    reports, 
    loading, 
    currentPage, 
    totalPages, 
    handlePageChange, 
    formatDate, 
    formatTime 
  } = useUserReports(user?.email);

  return (
    <div className="container max-w-4xl mx-auto px-4 py-8">
      <ReportsHeader />

      <Card className="shadow-lg">
        <CardContent className="p-6">
          {loading ? (
            <ReportLoading />
          ) : reports.length > 0 ? (
            <>
              <ReportsList 
                reports={reports} 
                formatDate={formatDate} 
                formatTime={formatTime}
                showTeacherDisplay={false}
                showAdminColumns={false}
              />
              
              {totalPages > 1 && (
                <ReportsPagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              )}
            </>
          ) : (
            <NoReportsFound />
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default TeacherReportsPage;
